// extracted by mini-css-extract-plugin
module.exports = {"login":"Login-module__login___2ulRr","link":"Login-module__link___1xGEW","white-background":"Login-module__white-background___3UbK6","sticky":"Login-module__sticky___14Wnz"};